import React, {useMemo} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {routeAccessibleForUser, securedRoutes, unsecuredRoutes} from "./routes";
import {RequireAuthentication} from "../../technical/auth/RequireAuthentication";
import {NotFoundPage} from "../page/NotFoundPage";
import {OidcUserProvider} from "../../technical/auth/OidcUserProvider";
import {AxiosProvider} from "../../technical/rest/AxiosProvider";
import {BasePage} from "../page/BasePage";
import {DrawerProvider} from "../drawer/DrawerProvider";
import {AccountProvider, useAccount} from "../../../administration/users/AccountProvider";
import {ApplicationsProvider} from "../../../administration/applications/ApplicationProvider";
import {QueryClient, QueryClientProvider} from "react-query";

export function MyRouter() {
  return (
    <BrowserRouter>
      <DrawerProvider>
        <Routes>
          {unsecuredRoutes.map(route => <Route key={route.path} path={route.path} element={route.component}/>)}
          <Route path={'*'} element={
            <OidcUserProvider>
              <RequireAuthentication>
                <AxiosProvider>
                  <QueryClientProvider client={new QueryClient({})}>
                    <ApplicationsProvider>
                      <AccountProvider>
                        <BasePage>
                          <SecuredRoutes/>
                        </BasePage>
                      </AccountProvider>
                    </ApplicationsProvider>
                  </QueryClientProvider>
                </AxiosProvider>
              </RequireAuthentication>
            </OidcUserProvider>
          }/>
        </Routes>
      </DrawerProvider>
    </BrowserRouter>
  );
}

function SecuredRoutes() {
  const account = useAccount();

  const accessibleRoutes = useMemo(() => securedRoutes.filter(routeAccessibleForUser(account)), [account]);

  return <Routes>
    {accessibleRoutes.map((route) => <Route path={route.path} key={route.path} element={route.component}/>)}
    <Route path={'*'} element={<NotFoundPage/>}/>
  </Routes>;
}
